import { useState } from "react";
import CreateSingleUser from "./CreateSingleUser";
import CreateBulkUsers from "./CreateBulkUsers";
import UploadUsersCSV from "./UploadUsersCSV";

export default function CreateUserPage({listId}) {

  const [tab, setTab] = useState("single");

  return (
    <div>

      <h2>Create Users</h2>

      <div style={{ marginBottom: 20 }}>
        <button onClick={() => setTab("single")}>Single</button>
        <button onClick={() => setTab("bulk")}>Bulk JSON</button>
        <button onClick={() => setTab("csv")}>Upload CSV</button>
      </div>

      {tab === "single" && <CreateSingleUser />}
      {tab === "bulk" && <CreateBulkUsers listId={listId} />}
      {tab === "csv" && <UploadUsersCSV listId={listId} />}

    </div>
  );
}